var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H12.388L13.511 2.633C13.713 2.025 13.611 1.351 13.236 0.831C12.861 0.311 12.253 0 11.612 0H10C9.703 0 9.422 0.132 9.231 0.36L4.531 6H2C0.897 6 0 6.897 0 8V17C0 18.103 0.897 19 2 19H15.307C15.7139 18.9986 16.1108 18.8738 16.4452 18.6421C16.7797 18.4103 17.0359 18.0825 17.18 17.702L19.937 10.351C19.9789 10.2387 20.0002 10.1198 20 10V8C20 6.897 19.103 6 18 6ZM2 8H4V17H2V8ZM18 9.819L15.307 17H6V7.362L10.468 2H11.614L10.052 6.683C10.0013 6.83331 9.98715 6.99355 10.0107 7.15043C10.0343 7.3073 10.095 7.45629 10.1877 7.58504C10.2803 7.71379 10.4024 7.8186 10.5436 7.89076C10.6849 7.96293 10.8414 8.00037 11 8H18V9.819Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbsUp);
export default __webpack_public_path__ + "static/media/icon-thumbs-up.78779f450392533cd7e3328e0e22f3bb.svg";
export { ForwardRef as ReactComponent };